import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiCall } from '../../utils/apiClient';
import { categories as staticCategories } from '../../constants/categories';

const staticItems = staticCategories.map((cat) => ({
  id: cat.id,
  name: cat.name,
  image: cat.image,
}));

const staticTopItems = [
  staticItems.find((cat) => cat.name === 'Refrigerator'),
  staticItems.find((cat) => cat.name === 'washing machine'),
  staticItems.find((cat) => cat.name === 'WOODEN Cupboard'),
  staticItems.find((cat) => cat.name === 'Wooden bed'),
  staticItems.find((cat) => cat.name === 'Sofa'),
].filter(Boolean);

export const fetchTopCategories = createAsyncThunk(
  'categories/fetchTopCategories',
  async () => {
    return await apiCall({ url: '/top-categories' });
  }
);

export const fetchCategories = createAsyncThunk(
  'categories/fetchCategories',
  async () => {
    return await apiCall({ url: '/categories' });
  }
);

const categoriesSlice = createSlice({
  name: 'categories',
  initialState: {
    topItems: staticTopItems,
    items: staticItems,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTopCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTopCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.topItems = action.payload;
      })
      .addCase(fetchTopCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default categoriesSlice.reducer;
